import APIClient from '../../../common/APIClient';
import { displayError } from '../commonActions';

const FETCH_DEPARTMENTS = 'FETCH_DEPARTMENTS';

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

export const fetchDepartments = () => {
  return (dispatch) => {
    client().get(
      'department/list'
    ).then(json => {
      const result = json.data;
      if (result) {
        let departments = result.data;
        
        if (!departments.length) {
          departments = null;
        }

        dispatch({type: FETCH_DEPARTMENTS, departments});
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}